module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-07.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-07.png
// module id = 1382
// module chunks = 0